export default "__VITE_ASSET__CkmW8xJd__"